import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';

export type AccountKey = string;

export interface ILeanAccount {
  number: string;
  name: string;
  nickName: string;
  selected: boolean;
  isLean: boolean;
}

export enum AccountType {
  Unknown = 'Unknown',
  Individual = 'Individual',
  Joint = 'Joint',
  Company = 'Company',
  CorporateTrust = 'CorporateTrust',
  Trust = 'Trust',
  SuperFund = 'SuperFund',
  Minor = 'Minor',
  RegisteredBody = 'RegisteredBody',
  Partnership = 'Partnership',
  OneOffSale = 'OneOffSale',
  EstateSale = 'EstateSale'
}

export enum MarginLendingProvider {
  Unknown = 'Unknown',
  CmcStgeorge = 'CmcStgeorge',
  StGeorge = 'StGeorge',
  LeveragedEquities = 'LeveragedEquities',
  Anz = 'Anz',
  Bt = 'Bt',
  Offline = 'Offline'
}

export interface IExtendedAccount {
  fiatSettlementCurrency: string;
  businessRegionId: number;
  cashAccount?: Partial<{
    no: string;
    bsb: string;
    instCode: string;
    canView: boolean;
  }>;
  chessAccountNumber: string;
  tier: string;
  directDebitLimit: number;
  isExternalCash: boolean;
  displayNonVettedCash: boolean;
  isExternalHoldings: boolean;
  displayNonVettedHoldings: boolean;
  isJointAccount: boolean;
  isCompanyAccount: boolean;
  type: AccountType;
  data?: Partial<{
    bankBalance: number;
    availableFunds: number;
    openBuyOrders: number;
    openBuyOrdersCount: number;
    sellOrdersCount: number;
    unsettledAmounts: number;
    tradesToday: number;
    tradesTodayCount: number;
    withdrawalAmount: number;
    stockHoldings: number;
    optionsMarginAmount: number;
  }>;
  hin: string;
  // otherClients: IOtherClients[];
  optionsAccountNumber: string;
  canTrade: boolean;
  isRealTimeBalance: boolean;
  primaryAdviser?: Partial<{
    code: string;
    name: string;
  }>;
  isUSTaxFormReceived: boolean;
  refreshGbstBalance: boolean;
  isMarginAccount: boolean;
  marginLendingProvider: MarginLendingProvider;
  cryptoOrdersEnabled: boolean;
}

export interface IAccount extends ILeanAccount, Partial<IExtendedAccount> {}

export interface IProfitLossItem {
  id: number;
  exchangeId: string;
  instrument: string;
  quantity: number;
  averagePrice: number;
  isUserHoldingQuantity: boolean;
  isUserAveragePrice: boolean;
  cost: number;
  instrumentDisplayCode: string;
}

export interface IAccountProfitLoss {
  items: IProfitLossItem[];
  pages: number;
  hash: number;
  hin: string;
  fiatSettlementCurrency: string;
  fiatSettlementCurrencySymbol: string;
  showHinNumber?: boolean;
}

// Note generated model does not match the actual property names
export interface CmcWebApiAccountHoldingLeanModel1 {
  Inst: string;
  Acc: string;
  ChH: number;
  Och: number;
  Avail: number;
  CS: number;
  CB: number;
  OS: number;
  OB: number;
  RB: number;
  RS: number;
  SecCat: string;
  Ex: string;
}

export interface IHoldingItem {
  instrument: string;
  chessHoldings: number;
  ochSubposition: number;
  availableHoldings: number;
  conditionalSells: number;
  conditionalBuys: number;
  openSells: number;
  openBuys: number;
  recentBuys: number;
  recentSells: number;
}

export interface IAccountHoldings {
  items: IHoldingItem[];
  hash: number;
}

export interface IAccountOptionHoldings {
  items: CmcWebApi.Account.AccountOptionPositionsModel1[];
}

export interface AccountOptionPositionsRequest1 {
  AccountFilter: string;
  IncludeIntraday: boolean;
  IncludePrices: boolean;
}

export type ConfirmationsKey = {
  accountNo: string;
  from: number;
  to: number;
};

export type ConfirmationsParamKey = ConfirmationsKey & {
  pageSize: number;
  sortColumn: string;
  sortDirection: Sort;
  page: number;
};

export interface IConfirmations {
  from: {
    [from: number]: {
      to: {
        [to: number]: {
          hash: number;
          count: number;
          params: {
            [pageSize_sortColumn_sortDirection: string]: {
              pages: {
                [page: number]: {
                  items: CmcWebApi.Account.ConfirmationModel3[];
                };
              };
            };
          };
        };
      };
    };
  };
}

export enum Sort {
  ASC = 'ASC',
  DESC = 'DESC'
}
